import React from 'react';
import { Hero } from './components/Hero';
import { QuoteSection } from './components/QuoteSection';
import { LearnSection } from './components/LearnSection';
import { WhoSection } from './components/WhoSection';
import { AboutCenia } from './components/AboutCenia';
import { EventDetails } from './components/EventDetails';
import { UrgencySection } from './components/UrgencySection';
import { Footer } from './components/Footer';
import { StickyCta } from './components/StickyCta';
export function App() {
  return <div className="w-full min-h-full bg-cream font-sans" data-id="element-0" data-mp="2mmvl6uoc8gbj">
      <Hero data-id="element-1" data-mp="31aqdi9yfoio3" />
      <main data-id="element-2" data-mp="31agpgrwy8ll1">
        <QuoteSection data-id="element-3" data-mp="31ayr642drs0c" />
        <LearnSection data-id="element-4" data-mp="31bianp7oiogh" />
        <WhoSection data-id="element-5" data-mp="31ctdnmtavs6j" />
        <AboutCenia data-id="element-6" data-mp="2wk0bn6p7uxy5" />
        <EventDetails data-id="element-7" data-mp="2wjgtppzkg9k4" />
        <UrgencySection data-id="element-8" data-mp="2wj8dbo48im46" />
      </main>
      <Footer data-id="element-9" data-mp="2wi5nzkmk8rqd" />
      <StickyCta data-id="element-10" data-mp="28ufm24yk52fw" />
    </div>;
}